import {asyncRoutes, constantRoutes} from '@/router'

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission_bak(roles, route) {
    if (route.meta && route.meta.roles) {
        return roles.some(role => route.meta.roles.includes(role))
    } else {
        return true
    }
}

function hasPermission(roles, premissions, route) {
    if (route.meta && route.meta.check) {
        if((route.meta.roles && roles.some(role => route.meta.roles.includes(role))) || checkPermission(premissions,route)){
            return true;
        }else{
            return false;
        }
    } else {
        return true;
    }
}

function checkPermission(premissions,route){
    return premissions.some((pre)=>{
        if(pre.split(":")[1] == route.name){
            return true
        }else{
            return false;
        }
    });
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes_bak(routes, roles) {
    const res = [];

    routes.forEach(route => {
        const tmp = {...route};
        if (hasPermission(roles, tmp)) {
            if (tmp.children) {
                tmp.children = filterAsyncRoutes(tmp.children, roles)
            }
            res.push(tmp)
        }
    });

    return res
}

export function filterAsyncRoutes(routes, roles ,premissions) {
    let res = [];
    routes.forEach(route => {
        const tmp = {...route};
        if (hasPermission(roles, premissions, tmp)) {
            if (tmp.children) {
                tmp.children = filterAsyncRoutes(tmp.children, roles ,premissions)
            }
            if (typeof tmp.children == 'undefined' || tmp.children.length > 0) {
                res.push(tmp)
            }
        }
    });
    return res;
}



const state = {
    routes: [],
    addRoutes: []
};

const mutations = {
    SET_ROUTES: (state, routes) => {
        state.addRoutes = routes;
        state.routes = constantRoutes.concat(routes)
    }
};

const actions = {
    generateRoutes_bak({commit}, roles) {
        return new Promise(resolve => {
            let accessedRoutes;
            if (roles.includes('admin')) {
                accessedRoutes = asyncRoutes || []
            } else {
                accessedRoutes = filterAsyncRoutes(asyncRoutes, roles)
            }
            commit('SET_ROUTES', accessedRoutes);
            resolve(accessedRoutes);
        })
    },
    generateRoutes({commit}, data) {
        let {roles,pers} = data;
        return new Promise(resolve => {
            let accessedRoutes;
            if (roles.includes('admin')) {
                //如果用户身份包括admin 则加载asyncRoutes
                accessedRoutes = asyncRoutes || [];
            } else {
                accessedRoutes = filterAsyncRoutes(asyncRoutes, roles , pers);
                for(let i=0;i<accessedRoutes.length;i++){
                    if(accessedRoutes[i].children && accessedRoutes[i].children.length == 0){
                        accessedRoutes.splice(i,1);
                        i-=1;
                    }
                }
            }
            commit('SET_ROUTES', accessedRoutes);
            resolve(accessedRoutes);
        })
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
